import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { isTeamsAppEnabled } from '../../common/utils/is-teams-app-enabled';
import { generatePath, generateTeamsAppPath, getHostProductFromPath, getPathAndQuery, onNavigateBase } from './utils';

/**
 * This function generates a URL for navigating to the Teams app based on the provided action.
 * This is not intended to be used within the Teams app itself.
 */
export var navigateToTeamsApp = function navigateToTeamsApp(action) {
  var hostProduct = action.hostProduct,
    shouldOpenInSameTab = action.shouldOpenInSameTab;
  var actionWithDefaults = _objectSpread(_objectSpread({}, action), {}, {
    /**
     * If teams app is enabled, default to opening in new tab.
     */
    shouldOpenInSameTab: shouldOpenInSameTab === undefined ? !isTeamsAppEnabled(action) : shouldOpenInSameTab,
    hostProduct: hostProduct || getHostProductFromPath()
  });
  var _getPathAndQuery = getPathAndQuery(actionWithDefaults),
    path = _getPathAndQuery.path,
    query = _getPathAndQuery.query;
  var href = generatePath(path, actionWithDefaults, query);
  var onNavigate = onNavigateBase(href, actionWithDefaults);
  var result = {
    onNavigate: onNavigate,
    href: href,
    target: actionWithDefaults.shouldOpenInSameTab ? '_self' : '_blank'
  };
  return result;
};

/**
 * This function generates a URL for navigating to the Teams app based on a path and search params.
 * This _always_ returns a Teams app URL, regardless of feature gates & context.
 */
export var toTeamsAppURL = function toTeamsAppURL(path, search, config) {
  return generateTeamsAppPath(path, config, new URLSearchParams(search));
};